export { default } from './TwoCellsWitheLeg';
